import {Route} from "../../registry/routes.js"
import Share from "../../components/miscellaneous/share.vue"

const r = new Route("share", "share", {"share":Share}, {componentType:"main_component", title: "Share"}, [], true, null)

export default r